import store from '@/store'

export default {
  getServiceRequestDraft: state => state.serviceRequestDraft || {},

  hasRelationshipWithCareship: () => () => {
    const storedDraft = store.getters['status/getServiceRequestDraft']
    const contracts = store.getters['mycaregivers/contracts']
    const requests = store.getters['mycaregivers/serviceRequests']

    const hasDrafts =
      typeof storedDraft === 'object' &&
      Object.prototype.hasOwnProperty.call(storedDraft, 'process_id')
    const hasContracts = contracts.length > 0
    const hasRequests = requests.length > 0

    return hasDrafts || hasContracts || hasRequests
  },
}
